<template>
    <div class="b-popup">
        <button class="calendar__close button-icon r-button" @click="closePopupInfo(cell)">
            <span class="screen-reader">Закрыть окно</span>
        </button>
        <template v-if="patientPhone">
            <div class="b-popup__header">
                <img :src="doctor.user.avatar" class="b-popup__photo avatar" alt="">
                <strong class="b-popup__mainmsg r-strong" v-html="`Остался один шаг для записи на ` + (cell.appointment.appointment_type.id === onlineType ? `онлайн-прием` : `приём`) + ` к ` + doctor.user.name"></strong>
            </div>
            <div class="b-popup__body">
                <label class="b-popup__select-pet field" v-if="patients">
                    <span class="field__caption">Выберите, кого Вы хотите записать</span>
                    <select class="r-select select" v-model="selectedPatient">
                        <option selected="" :value="index" v-for="(patient,index) in patients">{{ patient.name }}</option>
                    </select>
                </label>
                <div class="b-popup__meta">
                    <div class="b-popup__metagroup">
                        <span class="b-popup__metaname">Дата</span>
                        <span class="b-popup__metavalue">{{ consultation.time }}</span>
                    </div>
                    <div class="b-popup__metagroup" v-if="cell.appointment.appointment_type.id === onlineType">
                        <span class="b-popup__metaname">Стоимость онлайн-консультации:</span>
                        <span class="b-popup__metavalue">{{ doctor.lastPrice ? doctor.lastPrice + ' ₽' : 'Бесплатно' }} </span>
                    </div>
                    <div class="b-popup__metagroup" v-else>
                        <span class="b-popup__metaname">Адрес приема</span>
                        <span class="b-popup__metavalue">{{ doctor.clinic ? doctor.clinic.address : doctor.address }}</span>
                    </div>
                </div>
                <div class="b-popup__footer" v-if="doctor.lastPrice && cell.appointment.appointment_type.id === onlineType">
                    <span class="b-popup__metaname">При отмене консультации менее чем за 8 часов до ее начала, денежные средства возврату не подлежат.</span>
                </div>

                <div class="b-popup__footer" v-if="doctor.anon && cell.appointment.appointment_type.id === onlineType">
                    <label class="toggle">
                        <input type="checkbox" class="toggle__input screen-reader" v-model="anonym">
                        <span class="toggle__label">
                            <span class="toggle__text">Записаться анонимно</span>
                        </span>
                    </label>
                </div>

                <div class="b-popup__footer" v-if="doctor.lastPrice && cell.appointment.appointment_type.id === onlineType">
                    <button class="v-schedule__control r-button button" @click="paymentAppointment({cell: cell, selectedPatient: selectedPatient, anonym: anonym})">Оплатить</button>
                </div>
                <div class="b-popup__footer" v-else>
                    <button class="v-schedule__control r-button button" @click="createAppointment(selectedPatient)">Записаться</button>
                </div>
                <span class="v-schedule__comment" v-if="userTimeZoneName">Время по региону: {{ userTimeZoneName }} ({{ userTimeZoneOffset }}), <timezone-clock :timezone="userTimeZone"></timezone-clock></span>
            </div>
        </template>
        <template v-else>
            <div class="b-popup__header">
                <strong class="b-popup__mainmsg r-strong" v-html="`Вы не можете записаться на прием`"></strong>
            </div>
            <div class="b-popup__body" v-if="patients.length > 0">
                <div class="b-popup__select-pet field">
                    <span class="field__caption">Для записи на прием необходимо заполнить свои личные данные в разделе "Профиль"</span>
                </div>
                <div class="b-popup__footer">
                    <a class="r-link button" href="/account/profile">Профиль</a>
                </div>
            </div>
            <div class="b-popup__body" v-else>
                <div class="b-popup__select-pet field" v-if="user">
                    <span class="field__caption">Вы должны войти в систему как пациент, чтобы записаться на прием</span>
                </div>
                <div class="b-popup__select-pet field" v-else>
                    <span class="field__caption">Вы должны войти в систему, чтобы записаться на прием</span>
                    <ul class="profile__authactions r-list h-list">
                        <li class="h-list__group">
                            <a href="/login"  class="profile__login r-link button">Вход</a>
                        </li>
                        <li class="h-list__group">
                            <a href="/register" class="r-link">Регистрация</a>
                        </li>
                    </ul>
                </div>

            </div>
        </template>
    </div>
</template>

<script>
    import {mapMutations, mapState, mapActions} from 'vuex';
    import TimezoneClock from "../../widgets/clock/TimezoneClock";
    import ScheduleLogInMessage from "./../ScheduleLogInMessage.vue";

    export default {
        name: 'CalendarPopupBody',
        components: {
            TimezoneClock,
            ScheduleLogInMessage
        },
        data: () => ({
            patients: window.laravel.patients,
            selectedPatient: 0,
            patientPhone: window.laravel.patientPhone,
            onlineType: window.laravel.appointmentsTypes.online,
            anonym: false,
            user: window.laravel.user
        }),
        props: {
            cell: {
                type: Object,
                required: true
            },
        },
        computed: {
            ...mapState([
                'showModal',
                'access',
                'doctor',
                'consultation',
                'userTimeZone',
                'userTimeZoneOffset',
                'userTimeZoneName'
            ]),
        },
        methods: {
            ...mapActions([
                'makeAppointment',
                'paymentAppointment'
            ]),
            ...mapMutations([
                'closePopupInfo'
            ]),
            createAppointment(selectedPatient){
                this.makeAppointment({selectedPatient: selectedPatient, anonym: this.anonym});
            }
        },
    }
</script>

